import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Component to load the gigya script
 */
import React from 'react';
import PropTypes from 'prop-types';
import load from 'load-script';
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isEqual from 'lodash/isEqual';
import { onGigyaLoaded, fetchGigyaRatings, fetchGigyaComments } from './actions';
var GIGYA_URL = "https://cdns.gigya.com/JS/gigya.js?apiKey=".concat(process.env.GIGYA_PUBLIC_KEY);

var Gigya =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Gigya, _React$Component);

  function Gigya() {
    _classCallCheck(this, Gigya);

    return _possibleConstructorReturn(this, _getPrototypeOf(Gigya).apply(this, arguments));
  }

  _createClass(Gigya, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchGigyaData(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // fetch data if props change
      var categoryID = nextProps.categoryID; // deep compare array
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var streamIDs = !isEqual(nextProps.streamIDs, this.props.streamIDs) ? nextProps.streamIDs : null;
      var commentStreamID = // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      nextProps.commentStreamID !== this.props.commentStreamID ? nextProps.commentStreamID : null;
      this.fetchGigyaData({
        streamIDs: streamIDs,
        categoryID: categoryID,
        commentStreamID: commentStreamID
      });
    }
  }, {
    key: "fetchGigya",
    value: function fetchGigya(callback) {
      var _this = this;

      if (window.gigya) {
        return callback();
      }

      return load(GIGYA_URL, function (err) {
        if (err) {
          console.error(err);
          return;
        } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


        _this.props // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        .onGigyaLoaded(window.gigya, _this.props.commentStreamID).then(function () {
          callback();
        });
      });
    }
  }, {
    key: "fetchGigyaData",
    value: function fetchGigyaData(_ref) {
      var _this2 = this;

      var streamIDs = _ref.streamIDs,
          categoryID = _ref.categoryID,
          commentStreamID = _ref.commentStreamID;

      if (!streamIDs && !commentStreamID) {
        return;
      }

      this.fetchGigya(function () {
        if (streamIDs && categoryID) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          _this2.props.fetchGigyaRatings(streamIDs, categoryID);
        }

        if (commentStreamID) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          _this2.props.fetchGigyaComments(commentStreamID);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", null);
    }
  }]);

  return Gigya;
}(React.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


Gigya.defaultProps = {
  onGigyaLoaded: function onGigyaLoaded() {},
  categoryID: 'Credit Card Reviews',
  streamIDs: [],
  commentStreamID: null
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

Gigya.propTypes = {
  onGigyaLoaded: PropTypes.func,
  commentStreamID: PropTypes.string,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  fetchGigyaRatings: PropTypes.func,
  // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
  fetchGigyaComments: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  streamIDs: PropTypes.array,
  categoryID: PropTypes.string
};
export default connect(null, {
  onGigyaLoaded: onGigyaLoaded,
  fetchGigyaRatings: fetchGigyaRatings,
  fetchGigyaComments: fetchGigyaComments
})(Gigya);